import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { dateRangeValidator } from 'src/app/ads/util/form-validators';
import { getPassengersFileTable } from 'src/app/files/model/file-table';
import { PassengerCountRequest } from 'src/app/reports/service/bus-stop-report-file-preparator.service';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { FileType, getTabularFileTypes } from 'src/app/shared/model/file-type';

@Component({
  selector: 'app-passengers-count',
  templateUrl: './passengers-count.component.html',
  styleUrls: ['./passengers-count.component.scss']
})
export class PassengersCountComponent implements OnInit {

  fileTypeOptions = getTabularFileTypes();
  fileTypeEnum = FileType;
  reportOptions = getPassengersFileTable();
  defaultTime = [0, 0, 0];
  fileName: string;

  reportFormGroup: FormGroup = new FormGroup({
    report: new FormControl(null, [Validators.required]),
    fileType: new FormControl(null, [Validators.required]),
    startDate: new FormControl(null, [Validators.required,dateRangeValidator]),
    endDate: new FormControl(null, [Validators.required, dateRangeValidator])
  });

  constructor(public dialogRef: MatDialogRef<PassengersCountComponent>, public settingsService: UserSettingsService) { }

  ngOnInit(): void {
  }

  isValid(): boolean {
    return this.reportFormGroup.valid;
  }

  generate(): void {
    if (this.isValid()) {
      const controls = this.reportFormGroup.controls;
      const request = new PassengerCountRequest(
        controls.fileType.value, controls.report.value, controls.startDate.value, controls.endDate.value, this.fileName
      );
      this.dialogRef.close(request);
    }
  }

}
